import { CampoTexto } from "./CampoTexto";

export default CampoTexto;